<template>
<div>
  <button class="btn btn-accent text-white mb-2" @click="isActive = !isActive">Breakdown</button>
  <div v-if="isActive" class="">
    <tabs class="breakdown-content">
      <tab v-if="tab1_title" :name="tab1_title" :selected="true">
        <single-price-breakdown
          :breakdown="tab1_breakdown"
        >
        </single-price-breakdown>
      </tab>
      <tab v-if="tab2_title" :name="tab2_title">
        <single-price-breakdown
          :breakdown="tab2_breakdown"
        >
        </single-price-breakdown>
      </tab>
    </tabs>
  </div>

</div>
</template>
<style lang="scss">
.breakdown-content {
  border: 1px solid #eee;
  box-shadow: 0 1px 6px rgba(0,0,0,0.03);
  padding: 15px;
}
</style>
<script>
export default {
  data () {
    return {
      isActive: false
    }
  },
  props: [
  'tab1_breakdown',
  'tab2_breakdown',
  'tab1_title',
  'tab2_title',
  ],
}
</script>
